var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19C15.45 19 14.9793 18.8043 14.588 18.413C14.1967 18.0217 14.0007 17.5507 14 17V7C14 6.45 14.196 5.97933 14.588 5.588C14.98 5.19667 15.4507 5.00067 16 5C16.5493 4.99934 17.0203 5.19533 17.413 5.588C17.8057 5.98067 18.0013 6.45133 18 7V17C18 17.55 17.8043 18.021 17.413 18.413C17.0217 18.805 16.5507 19.0007 16 19ZM8 19C7.45 19 6.97933 18.8043 6.588 18.413C6.19667 18.0217 6.00067 17.5507 6 17V7C6 6.45 6.196 5.97933 6.588 5.588C6.98 5.19667 7.45067 5.00067 8 5C8.54933 4.99934 9.02033 5.19533 9.413 5.588C9.80567 5.98067 10.0013 6.45133 10 7V17C10 17.55 9.80433 18.021 9.413 18.413C9.02167 18.805 8.55067 19.0007 8 19Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.adfb9b08ec51c7d5fe3ffffaded8bedd.svg";
export { ForwardRef as ReactComponent };